export const tradingManageSearchResSample = {
  tradingInfo: {
    tradingId: 'T202406050000003',
    tradingName: '大塚_テスト',
    tradingPatternId: 'TP00000417',
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    tradingCreateUserId: 'US00001073',
    tradingCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
    tradingCreateUserIcon:
      '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
    tradingCreateDate: '2024-06-05T02:16:39Z',
    tradingUpdateUserId: 'US00001073',
    tradingUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
    tradingUpdateUserIcon:
      '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
    tradingUpdateDate: '2025-06-25T08:44:34Z',
    tradingSubmitStatusCd: 2,
    totalTradingProgressStatusCd: 1,
    editableFlg: 1,
    isOwnerFlg: 1,
    tradingFlowList: [
      {
        linkageInfo: {
          invoiceNo: '1234',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: '2024-11-08',
          eta: '2024-10-31',
          dischargingEta: '2024-10-31',
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: '2024-11-01',
          portOfLoadingName: null,
          portOfDischargingName: 'AABENRAA <DKAAB> ',
          imRequestDeclarationDate: null,
          deliveryDate: '2024-10-31',
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '1',
        tradingManageName: '2',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
        flowCreateDate: '2024-06-05T02:16:39Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000009408',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-06-10T09:20:54Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001052',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'ESC000000009408',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EAG000000001134',
            entityTypeCd: 8,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-18T05:22:07Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPARB',
                processSeq: 1,
                processSortNo: 320,
                processName: 'Prepare Shipment',
                processUserMemo: '',
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-18T05:22:07Z',
                processUpdateUserId: 'US00001083',
                processUpdateUserName: 'Carrier1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-18T07:06:46Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'ELC000000001052',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000010436',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-01-14T03:15:53Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001077',
                processUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-12-09T05:07:56Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'EAG000000001134',
                prevEntityTypeCd: 8,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000005987',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2024-12-05T07:02:54Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2024-11-01T00:27:00Z',
                dueBaseDate: '2024-10-31',
                calculatedDueDate: '2024-10-28',
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2024-10-31T12:32:37Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'EEC000000010436',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000006173',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: '2024-10-31',
                calculatedDueDate: '2024-10-28',
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'ETP000000005987',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000005596',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: '2024-11-08',
                calculatedDueDate: '2024-11-11',
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'EMI000000006173',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000007549',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-05T02:16:39Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1223',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-11-01T05:43:06Z',
                dueBaseDate: '2024-10-31',
                calculatedDueDate: '2024-10-28',
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000722',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000267',
                toCompanyShortName: 'ForwarderIm1_forDevCS',
                toCompanyName: 'ForwarderIm1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001075',
                processCreateUserName: 'Importer1_forDevCS_Org1_PIC',
                processCreateUserIcon: '/files/tw/users/default/icon.png',
                processCreateDate: '2024-12-24T07:23:29Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-12-24T07:25:38Z',
                dueBaseDate: '2024-10-31',
                calculatedDueDate: '2024-10-28',
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-05T02:16:39Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-21T09:33:37Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '1',
                prevEntityId: 'EFD000000005596',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20240605000003',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1',
          contractNo: '1111',
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '2',
        tradingManageName: 'PB-920',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
        flowCreateDate: '2024-06-12T08:30:45Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000009424',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'NC00001038',
                fromSectionShortName: 'NACCS Section',
                fromSectionName: 'NACCS Section',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-06-12T08:52:06Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001060',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processUpdateDate: '2024-06-12T08:37:28Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '2',
                prevEntityId: 'ESC000000009424',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000010449',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-08-07T03:01:22Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-04T06:54:12Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '2',
                prevEntityId: 'ELC000000001060',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000005996',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processUpdateDate: '2024-06-12T08:43:10Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '2',
                prevEntityId: 'EEC000000010449',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000006183',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processUpdateDate: '2024-06-12T08:44:49Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '2',
                prevEntityId: 'ETP000000005996',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000005606',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processUpdateDate: '2024-06-12T08:47:08Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '2',
                prevEntityId: 'EMI000000006183',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000007562',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-06-12T08:30:45Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-01-21T03:00:50Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000722',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000267',
                toCompanyShortName: 'ForwarderIm1_forDevCS',
                toCompanyName: 'ForwarderIm1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001075',
                processCreateUserName: 'Importer1_forDevCS_Org1_PIC',
                processCreateUserIcon: '/files/tw/users/default/icon.png',
                processCreateDate: '2024-12-24T07:23:29Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-12-24T07:26:10Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-06-12T08:30:45Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '2',
                prevEntityId: 'EFD000000005606',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20240612000002',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1',
          contractNo: '1',
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: 100,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bag',
          contractTotalAmount: 10000,
          contractCurrencyId: 'JPY',
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '7',
        tradingManageName: '4',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
        flowCreateDate: '2024-07-01T05:22:53Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000009457',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 6,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-09-03T00:11:37Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 1,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001085',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'ESC000000009457',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EAG000000000835',
            entityTypeCd: 8,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-19T03:10:28Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPARB',
                processSeq: 1,
                processSortNo: 320,
                processName: 'Request Booking',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-18T08:17:26Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'ELC000000001085',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000010495',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-08-07T03:05:13Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECREQ03',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-09-03T05:53:02Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECREQ04',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2024-10-17T02:56:53Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECREQ05',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'EAG000000000835',
                prevEntityTypeCd: 8,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000006018',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-18T08:22:34Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI02',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'EEC000000010495',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000006206',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIRIP01',
                processSeq: 1,
                processSortNo: 500,
                processName: 'Request Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'MIRIP02',
                processSeq: 1,
                processSortNo: 501,
                processName: 'Request Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'MIRIP03',
                processSeq: 1,
                processSortNo: 502,
                processName: 'Request Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'ETP000000006018',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000005637',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR01',
                processSeq: 1,
                processSortNo: 820,
                processName: 'Request Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI01',
                processSeq: 1,
                processSortNo: 821,
                processName: 'Issue Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR02',
                processSeq: 1,
                processSortNo: 822,
                processName: 'Request Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI02',
                processSeq: 1,
                processSortNo: 823,
                processName: 'Issue Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR03',
                processSeq: 1,
                processSortNo: 824,
                processName: 'Request Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI03',
                processSeq: 1,
                processSortNo: 825,
                processName: 'Issue Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR04',
                processSeq: 1,
                processSortNo: 826,
                processName: 'Request Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI04',
                processSeq: 1,
                processSortNo: 827,
                processName: 'Issue Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR05',
                processSeq: 1,
                processSortNo: 828,
                processName: 'Request Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI05',
                processSeq: 1,
                processSortNo: 829,
                processName: 'Issue Certificate of Origin',
                processUserMemo: null,
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'EMI000000006206',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000007600',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
            entityCreateDate: '2024-07-01T05:22:53Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-12-24T07:26:36Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-09-18T07:37:52Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ03',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-09-18T07:39:20Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ04',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ05',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-19T03:10:28Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2023-02-15T03:51:00Z/2024-05-22T08:37:52Z/icon/US00001073_1716367072000.png',
                processCreateDate: '2024-07-01T05:22:53Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '7',
                prevEntityId: 'EFD000000005637',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20240701000006',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: 1000,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bag',
          contractTotalAmount: 1000000,
          contractCurrencyId: 'JPY',
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '27',
        tradingManageName: 'combine',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2024-10-17T02:58:07Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000009935',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-10-17T02:58:07Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-10-17T02:58:07Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-10-17T04:30:13Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-10-17T02:58:07Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001325',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-10-17T02:58:07Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-10-17T02:58:07Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '27',
                prevEntityId: 'ESC000000009935',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000011240',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-10-17T02:58:07Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-10-17T02:58:07Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-10-17T04:35:53Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-10-17T02:58:07Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '27',
                prevEntityId: 'ELC000000001325',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 1,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 1,
          canCombineFlg: 1,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20241017000001',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: 1000,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bag',
          contractTotalAmount: 1000000,
          contractCurrencyId: 'JPY',
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: '',
          vesselBookingNo: '',
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '29',
        tradingManageName: '29',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2024-11-27T07:09:59Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ETP000000007063',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-27T07:09:59Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T07:09:59Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T07:09:59Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T07:09:59Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T07:09:59Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '27',
                prevEntityId: 'EEC000000011240',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000007263',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-27T09:00:54Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T09:00:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '29',
                prevEntityId: 'ETP000000007063',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000006782',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-27T09:00:54Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T09:00:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T09:00:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '29',
                prevEntityId: 'EMI000000007263',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000009004',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-27T09:00:54Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T09:00:54Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-01-20T03:01:32Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-27T09:00:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '29',
                prevEntityId: 'EFD000000006782',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 1,
          combineFlg: 0,
          parentFlowInfo: [
            {
              parentTradingId: 'T202406050000003',
              parentFlowId: '27',
              mainCombineFlg: 0,
            },
          ],
          canPartialShipmentFlg: 1,
          canCombineFlg: 1,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20241017000001',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1234',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '28',
        tradingManageName: '28',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2024-11-22T06:21:58Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000010115',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-14T08:00:10Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001366',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '28',
                prevEntityId: 'ESC000000010115',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000011706',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-01-14T03:54:55Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECREQ02',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: '',
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-01-14T03:57:01Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-12T06:39:21Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECREQ03',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: '',
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-01-14T08:46:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-05-23T08:44:14Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECREQ04',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: '',
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000924',
                toSectionShortName:
                  'Sec2\\nSec2Sec2Sec2Sec2Sec2Sec2Sec2Sec2Sec2\\nSec2Sec2Sec2Sec2',
                toSectionName: 'Sec2',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-01-16T00:24:14Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-21T06:10:16Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '28',
                prevEntityId: 'ELC000000001366',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000006822',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T03:11:37Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-01-27T05:55:20Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '28',
                prevEntityId: 'EEC000000011706',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000007014',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '28',
                prevEntityId: 'ETP000000006822',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000006532',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '28',
                prevEntityId: 'EMI000000007014',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000008751',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2024-11-22T06:21:58Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1234',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: 'US00001075',
                processUpdateUserName: 'Importer1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2024-12-24T07:27:06Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-21T07:50:08Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-25T06:11:51Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ03',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-18T10:12:26Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-19T05:05:56Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ04',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-19T05:07:42Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-19T05:47:37Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ05',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-19T05:07:42Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-19T05:52:05Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2024-11-22T06:21:58Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '28',
                prevEntityId: 'EFD000000006532',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20241122000015',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '11',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '32',
        tradingManageName: '32',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-02-05T06:19:49Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000010684',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000924',
                toSectionShortName:
                  'Sec2\\nSec2Sec2Sec2Sec2Sec2Sec2Sec2Sec2Sec2\\nSec2Sec2Sec2Sec2',
                toSectionName: 'Sec2',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001457',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'ESC000000010684',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EAG000000001142',
            entityTypeCd: 8,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-18T08:09:52Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPARB',
                processSeq: 1,
                processSortNo: 320,
                processName: 'Prepare Shipment',
                processUserMemo: '',
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-18T08:09:52Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-18T08:12:07Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'ELC000000001457',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000012929',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-02-05T06:20:52Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'EAG000000001142',
                prevEntityTypeCd: 8,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000007863',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'EEC000000012929',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008042',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'ETP000000007863',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000007583',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'EMI000000008042',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000009963',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-02-05T06:19:49Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '11',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-02-21T05:10:58Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-06T23:58:37Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-02-21T04:18:09Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ03',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-06T23:58:37Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-02-20T11:41:13Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ04',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 6,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-06T23:58:37Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-02-25T00:02:47Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ05',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-14T05:12:46Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-02-05T06:19:49Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '32',
                prevEntityId: 'EFD000000007583',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250205000003',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '222',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: 1000,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bag',
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '33',
        tradingManageName: 'Partial',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-03-06T06:52:54Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000010840',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-06T06:52:54Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-06T06:52:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-06T06:52:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001509',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-06T06:52:54Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-06T06:52:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '33',
                prevEntityId: 'ESC000000010840',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000013148',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-06T06:52:54Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-06T06:52:54Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-06T06:54:10Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-06T06:52:54Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '33',
                prevEntityId: 'ELC000000001509',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 1,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 1,
          canCombineFlg: 1,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250306000010',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '222',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bag',
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '34',
        tradingManageName: '34',
        tradingProgressStatusCd: 0,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-03-07T04:27:22Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ETP000000008033',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:27:22Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '33',
                prevEntityId: 'EEC000000013148',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008212',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:27:22Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '34',
                prevEntityId: 'ETP000000008033',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000007808',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:27:22Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '34',
                prevEntityId: 'EMI000000008212',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010220',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:27:22Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:27:22Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '34',
                prevEntityId: 'EFD000000007808',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 1,
          combineFlg: 0,
          parentFlowInfo: [
            {
              parentTradingId: 'T202406050000003',
              parentFlowId: '33',
              mainCombineFlg: 0,
            },
          ],
          canPartialShipmentFlg: 1,
          canCombineFlg: 1,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250306000010',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '222',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bag',
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '35',
        tradingManageName: '35',
        tradingProgressStatusCd: 0,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-03-07T04:29:19Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ETP000000008034',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:29:19Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking(TP)',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '33',
                prevEntityId: 'EEC000000013148',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008213',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:29:19Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '35',
                prevEntityId: 'ETP000000008034',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000007809',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:29:19Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '35',
                prevEntityId: 'EMI000000008213',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010221',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-07T04:29:19Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-07T04:29:19Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '35',
                prevEntityId: 'EFD000000007809',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 1,
          combineFlg: 0,
          parentFlowInfo: [
            {
              parentTradingId: 'T202406050000003',
              parentFlowId: '33',
              mainCombineFlg: 0,
            },
          ],
          canPartialShipmentFlg: 1,
          canCombineFlg: 1,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250306000010',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: null,
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '36',
        tradingManageName: 'PB-1119',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-03-11T08:32:15Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000010894',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T05:03:36Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T09:42:43Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001525',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T03:12:40Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'ESC000000010894',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EAG000000001128',
            entityTypeCd: 8,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-12T06:49:30Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPARB',
                processSeq: 1,
                processSortNo: 320,
                processName: 'Prepare Shipment',
                processUserMemo: '',
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-12T06:49:30Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T03:12:07Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'ELC000000001525',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000013240',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T09:59:27Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-21T07:26:08Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'EAG000000001128',
                prevEntityTypeCd: 8,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000008096',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T09:57:32Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T09:46:35Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001083',
                processUpdateUserName: 'Carrier1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-13T10:00:29Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:02:18Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'EEC000000013240',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008275',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'MIRIP01',
                processSeq: 1,
                processSortNo: 500,
                processName: 'Request Insurance Policy',
                processUserMemo: '',
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00001505',
                toSectionShortName: 'Sec1',
                toSectionName: 'Section1',
                toCustomerId: null,
                toCompanyId: 'CO00000424',
                toCompanyShortName: 'Exporter&Logi1_forDEVCS',
                toCompanyName: 'Exporter&Logi1_forDEVCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-13T09:21:57Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:06:43Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:07:30Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'ETP000000008096',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000007871',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:08:03Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR01',
                processSeq: 1,
                processSortNo: 820,
                processName: 'Request Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00001507',
                toSectionShortName: 'Sec1',
                toSectionName: 'Section1',
                toCustomerId: null,
                toCompanyId: 'CO00000425',
                toCompanyShortName: 'CommerceAndIndustry1_forDevCS',
                toCompanyName: 'CommerceAndIndustry1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-13T06:56:28Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:08:30Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI01',
                processSeq: 1,
                processSortNo: 821,
                processName: 'Issue Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-13T09:21:57Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-13T10:11:20Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-11T08:44:59Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'EMI000000008275',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010285',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-11T08:32:15Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:12:21Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-11T08:32:15Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-03-13T10:12:55Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '36',
                prevEntityId: 'EFD000000007871',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250311000013',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: 'Inv12',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: 2.2,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bags',
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '37',
        tradingManageName: '37',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-03-21T04:32:50Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000010930',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001539',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'Inv12',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '37',
                prevEntityId: 'ESC000000010930',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000013294',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'Inv12',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-28T08:38:59Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '37',
                prevEntityId: 'ELC000000001539',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000008158',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'Inv12',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '37',
                prevEntityId: 'EEC000000013294',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008328',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'Inv12',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'MIRIP01',
                processSeq: 1,
                processSortNo: 500,
                processName: 'Request Insurance Policy',
                processUserMemo: '',
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T08:29:59Z',
                processUpdateUserId: 'US00001077',
                processUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-28T08:47:52Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '37',
                prevEntityId: 'ETP000000008158',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000007926',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'Inv12',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR01',
                processSeq: 1,
                processSortNo: 820,
                processName: 'Request Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-25T03:22:24Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-26T01:16:51Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR02',
                processSeq: 1,
                processSortNo: 822,
                processName: 'Request Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-26T01:21:20Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-26T01:39:20Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '37',
                prevEntityId: 'EMI000000008328',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010341',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-21T04:32:50Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'Inv12',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-21T04:32:50Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '37',
                prevEntityId: 'EFD000000007926',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 1,
          canCombineFlg: 1,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250321000006',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: 'INV',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: 4.4,
          contractTotalQuantityUnitId: 'BG',
          contractQuantityUnit: 'Bags',
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '38',
        tradingManageName: 'PB-967',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-03-28T02:02:14Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'EEC000000013320',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-28T02:02:14Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'INV',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: 'PB-1048_test',
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-28T02:02:14Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-03-28T08:04:07Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008353',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-03-28T02:02:14Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: 'INV',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'MIRIP01',
                processSeq: 1,
                processSortNo: 500,
                processName: 'Request Insurance Policy',
                processUserMemo: '',
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-03-28T02:02:14Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Automatic approval',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-04-02T01:15:47Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '38',
                prevEntityId: 'EEC000000013320',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250328000001',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1111',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '39',
        tradingManageName: 'PB-1072',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-04-15T04:59:06Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000011009',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'NC00001038',
                toSectionShortName: 'NACCS Section',
                toSectionName: 'NACCS Section',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:00:30Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:01:52Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001576',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:02:27Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'ESC000000011009',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EAG000000001187',
            entityTypeCd: 8,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPARB',
                processSeq: 1,
                processSortNo: 320,
                processName: 'Prepare Shipment',
                processUserMemo: '',
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:03:11Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'ELC000000001576',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000013403',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001077',
                processUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-04-15T08:09:17Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:04:55Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'EAG000000001187',
                prevEntityTypeCd: 8,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000008257',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:05:34Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:30:52Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001083',
                processUpdateUserName: 'Carrier1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-04-15T05:33:46Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:08:29Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'EEC000000013403',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008436',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'MIRIP01',
                processSeq: 1,
                processSortNo: 500,
                processName: 'Request Insurance Policy',
                processUserMemo: '',
                processType: 'PT_MIRIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:10:07Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:11:23Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'ETP000000008257',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000008031',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1111',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:12:43Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR01',
                processSeq: 1,
                processSortNo: 820,
                processName: 'Request Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000743',
                toSectionShortName: 'Test JCCI',
                toSectionName: 'Test JCCI',
                toCustomerId: null,
                toCompanyId: 'CO00000283',
                toCompanyShortName: 'Test JCCI',
                toCompanyName: 'Test JCCI',
                toCompanyIcon: '',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:14:05Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI01',
                processSeq: 1,
                processSortNo: 821,
                processName: 'Issue Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001077',
                processUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-04-15T07:10:13Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:16:54Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'EMI000000008436',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010460',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-04-15T04:59:06Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:17:57Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-04-15T04:59:06Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-04-15T05:18:52Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '39',
                prevEntityId: 'EFD000000008031',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250415000004',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '1222',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '40',
        tradingManageName: 'PB-1205',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-06-04T06:50:41Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000011223',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001647',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '40',
                prevEntityId: 'ESC000000011223',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000013769',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1222',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 5,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: 'US00001077',
                processUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-06-13T00:48:08Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '40',
                prevEntityId: 'ELC000000001647',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000008495',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '40',
                prevEntityId: 'EEC000000013769',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008676',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '40',
                prevEntityId: 'ETP000000008495',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000008295',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1222',
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR01',
                processSeq: 1,
                processSortNo: 820,
                processName: 'Request Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00001507',
                toSectionShortName: 'Sec1',
                toSectionName: 'Section1',
                toCustomerId: null,
                toCompanyId: 'CO00000425',
                toCompanyShortName: 'CommerceAndIndustry1_forDevCS',
                toCompanyName: 'CommerceAndIndustry1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-06T01:54:24Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI01',
                processSeq: 1,
                processSortNo: 821,
                processName: 'Issue Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-06T01:54:24Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '40',
                prevEntityId: 'EMI000000008676',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010727',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-04T06:50:41Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: '1222',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 1,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-19T07:18:21Z',
                processUpdateUserId: 'US00001073',
                processUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processUpdateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processUpdateDate: '2025-06-19T07:37:32Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-04T06:50:41Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '40',
                prevEntityId: 'EFD000000008295',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250604000007',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: '232352',
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '41',
        tradingManageName: 'PB-519',
        tradingProgressStatusCd: 1,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-06-23T09:04:27Z',
        flowUpdateUserId: 'US00001077',
        flowUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
        flowUpdateUserIcon: '/files/tw/users/default/icon.png',
        flowUpdateDate: '2025-06-26T01:29:39Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'EIC000000010844',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-23T09:04:27Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T12:57:12Z',
            no: '232352',
            entityProgressStatusCd: 1,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 3,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-23T09:04:27Z',
                processUpdateUserId: 'US00001077',
                processUpdateUserName: 'ForwarderEx1_forDevCS_Org1_PIC',
                processUpdateUserIcon: '/files/tw/users/default/icon.png',
                processUpdateDate: '2025-06-26T01:29:39Z',
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ02',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-23T09:04:27Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ03',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-23T09:04:27Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ04',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-23T09:04:27Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICREQ05',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: '',
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-23T09:04:27Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-23T09:04:27Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250623000004',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
      {
        linkageInfo: {
          invoiceNo: null,
          contractNo: null,
          contractDate: null,
          sellerName: null,
          buyerName: null,
          contractGroupOfGoods: null,
          contractTotalQuantity: null,
          contractTotalQuantityUnitId: null,
          contractQuantityUnit: null,
          contractTotalAmount: null,
          contractCurrencyId: null,
          blDate: null,
          eta: null,
          dischargingEta: null,
          nameOfVessel: null,
          blNo: null,
          vesselBookingNo: null,
          numberOfContainers: null,
          dischargingCurrentEta: null,
          portOfLoadingName: null,
          portOfDischargingName: null,
          imRequestDeclarationDate: null,
          deliveryDate: null,
          devanningPlace: null,
          warehouse: null,
          freeTime: null,
          exRequestDeclarationDate: null,
          vanningDate: null,
          vanningPlace: null,
          cyCutDate: null,
        },
        otherTradingFlg: 0,
        otherTradingName: null,
        otherTradingId: null,
        tradingFlowId: '42',
        tradingManageName: 'PB-1399',
        tradingProgressStatusCd: 0,
        forcedClose: 0,
        flowDeleteFlg: 0,
        flowCreateUserId: 'US00001073',
        flowCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowCreateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowCreateDate: '2025-06-25T08:44:34Z',
        flowUpdateUserId: 'US00001073',
        flowUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
        flowUpdateUserIcon:
          '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
        flowUpdateDate: '2025-06-25T08:44:34Z',
        flowDetailViewableFlg: 1,
        entityStatus: [
          {
            entityId: 'ESC000000011343',
            entityTypeCd: 1,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'COPO',
                processSeq: 1,
                processSortNo: 100,
                processName: 'Send Purchase Order',
                processUserMemo: null,
                processType: 'PT_COPO',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'COCOS',
                processSeq: 1,
                processSortNo: 110,
                processName: 'Issue Contract',
                processUserMemo: null,
                processType: 'PT_COCOS',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ELC000000001677',
            entityTypeCd: 2,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'LCACCEPT',
                processSeq: 1,
                processSortNo: 210,
                processName: 'Store Letter of Credit',
                processUserMemo: null,
                processType: 'PT_LCACCEPT',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'LC00001036',
                toSectionShortName: 'LC Section',
                toSectionName: 'LC Section',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '42',
                prevEntityId: 'ESC000000011343',
                prevEntityTypeCd: 1,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EEC000000013944',
            entityTypeCd: 3,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'ECREQ01',
                processSeq: 1,
                processSortNo: 400,
                processName: 'Exp. Shipping Instruction',
                processUserMemo: null,
                processType: 'PT_ECREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'ECPERMIT',
                processSeq: 1,
                processSortNo: 430,
                processName: 'Store Ex. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ECPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '42',
                prevEntityId: 'ELC000000001677',
                prevEntityTypeCd: 2,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'ETP000000008602',
            entityTypeCd: 5,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'TPRB',
                processSeq: 1,
                processSortNo: 705,
                processName: 'Request Booking',
                processUserMemo: null,
                processType: 'PT_TPATPRB',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPRBL',
                processSeq: 1,
                processSortNo: 710,
                processName: 'Request Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPRBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000724',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000268',
                toCompanyShortName: 'Carrier1_forDevCS',
                toCompanyName: 'Carrier1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBLI01',
                processSeq: 1,
                processSortNo: 720,
                processName: 'Bill of Lading Information',
                processUserMemo: null,
                processType: 'PT_TPBLI',
                fromRoleId: null,
                fromSectionId: 'SE00000724',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000268',
                fromCompanyShortName: 'Carrier1_forDevCS',
                fromCompanyName: 'Carrier1_forDevCS',
                fromCompanyIcon: '',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'TPBL',
                processSeq: 1,
                processSortNo: 740,
                processName: 'Store Bill of Lading',
                processUserMemo: null,
                processType: 'PT_TPBL',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '42',
                prevEntityId: 'EEC000000013944',
                prevEntityTypeCd: 3,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EMI000000008785',
            entityTypeCd: 4,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'MIIP',
                processSeq: 1,
                processSortNo: 520,
                processName: 'Store Insurance Policy',
                processUserMemo: null,
                processType: 'PT_MIIP',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '42',
                prevEntityId: 'ETP000000008602',
                prevEntityTypeCd: 5,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EFD000000008408',
            entityTypeCd: 6,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'FDCRTDOC',
                processSeq: 1,
                processSortNo: 810,
                processName: 'Create Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDCRTDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOR01',
                processSeq: 1,
                processSortNo: 820,
                processName: 'Request Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOR',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00001507',
                toSectionShortName: 'Sec1',
                toSectionName: 'Section1',
                toCustomerId: null,
                toCompanyId: 'CO00000425',
                toCompanyShortName: 'CommerceAndIndustry1_forDevCS',
                toCompanyName: 'CommerceAndIndustry1_forDevCS',
                toCompanyIcon: '',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDCOI01',
                processSeq: 1,
                processSortNo: 821,
                processName: 'Issue Certificate of Origin',
                processUserMemo: '',
                processType: 'PT_FDCOI',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000713',
                toSectionShortName: 'Sec1_en_short',
                toSectionName: 'Sec1_en',
                toCustomerId: null,
                toCompanyId: 'CO00000262',
                toCompanyShortName: 'Exporter1_forDevCS',
                toCompanyName: 'Exporter1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
              {
                processId: 'FDDOC',
                processSeq: 1,
                processSortNo: 830,
                processName: 'Send Shipping Documents',
                processUserMemo: null,
                processType: 'PT_FDDOC',
                fromRoleId: null,
                fromSectionId: 'SE00000713',
                fromSectionShortName: 'Sec1_en_short',
                fromSectionName: 'Sec1_en',
                fromCustomerId: null,
                fromCompanyId: 'CO00000262',
                fromCompanyShortName: 'Exporter1_forDevCS',
                fromCompanyName: 'Exporter1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 1,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '42',
                prevEntityId: 'EMI000000008785',
                prevEntityTypeCd: 4,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
          {
            entityId: 'EIC000000010863',
            entityTypeCd: 7,
            entityCreateUserId: 'US00001073',
            entityCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityCreateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityCreateDate: '2025-06-25T08:44:34Z',
            entityUpdateUserId: 'US00001073',
            entityUpdateUserName: 'Exporter1_forDevCS_Org1_PIC',
            entityUpdateUserIcon:
              '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
            entityUpdateDate: '2025-06-25T08:44:34Z',
            no: null,
            entityProgressStatusCd: 0,
            processStatus: [
              {
                processId: 'ICREQ01',
                processSeq: 1,
                processSortNo: 900,
                processName: 'Imp. Instruction',
                processUserMemo: null,
                processType: 'PT_ICREQ',
                fromRoleId: null,
                fromSectionId: 'SE00000716',
                fromSectionShortName: 'Sec1_Short\\nLong',
                fromSectionName: 'Sec1_Long\\nLong',
                fromCustomerId: null,
                fromCompanyId: 'CO00000264',
                fromCompanyShortName: 'Importer1_ShortName',
                fromCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000720',
                toSectionShortName: 'Sec1',
                toSectionName: 'Sec1',
                toCustomerId: null,
                toCompanyId: 'CO00000266',
                toCompanyShortName: 'ForwarderEx1_forDevCS',
                toCompanyName: 'ForwarderEx1_forDevCS',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
              {
                processId: 'ICPERMIT',
                processSeq: 1,
                processSortNo: 930,
                processName: 'Store Im. Customs Permit',
                processUserMemo: null,
                processType: 'PT_ICPERMIT',
                fromRoleId: null,
                fromSectionId: 'SE00000720',
                fromSectionShortName: 'Sec1',
                fromSectionName: 'Sec1',
                fromCustomerId: null,
                fromCompanyId: 'CO00000266',
                fromCompanyShortName: 'ForwarderEx1_forDevCS',
                fromCompanyName: 'ForwarderEx1_forDevCS',
                fromCompanyIcon: '/files/tw/companies/default/icon.png',
                toRoleId: null,
                toSectionId: 'SE00000716',
                toSectionShortName: 'Sec1_Short\\nLong',
                toSectionName: 'Sec1_Long\\nLong',
                toCustomerId: null,
                toCompanyId: 'CO00000264',
                toCompanyShortName: 'Importer1_ShortName',
                toCompanyName:
                  'Importer1_ Long Na\\nLong Na\\nLong NameLong NameLong NameLong NameLong NameLong NameLong NameLong Nam',
                toCompanyIcon: '/files/tw/companies/default/icon.png',
                processProgressStatusCd: 0,
                processDeleteFlg: 0,
                approvalRequired: 0,
                toUnassignedAllow: 0,
                processCreateUserId: 'US00001073',
                processCreateUserName: 'Exporter1_forDevCS_Org1_PIC',
                processCreateUserIcon:
                  '/files/tw/users/US00001073/2024-06-27T09:40:00Z/2024-09-26T07:58:27Z/icon/US00001073_1727337507000.png',
                processCreateDate: '2025-06-25T08:44:34Z',
                processUpdateUserId: null,
                processUpdateUserName: null,
                processUpdateUserIcon: null,
                processUpdateDate: null,
                dueBaseDate: null,
                calculatedDueDate: null,
                eventCancel: 0,
                visibleFlg: 1,
                detailViewableFlg: 0,
              },
            ],
            prevEntityStatus: [
              {
                prevTradingId: 'T202406050000003',
                prevTradingFlowId: '42',
                prevEntityId: 'EFD000000008408',
                prevEntityTypeCd: 6,
              },
            ],
            totalAmountInfo: {
              remainingQuantity: null,
              totalQuantity: null,
              unit1: null,
            },
          },
        ],
        subordinateInfo: {
          parentFlg: 0,
          subFlg: 0,
          combineFlg: 0,
          parentFlowInfo: [
            { parentTradingId: null, parentFlowId: null, mainCombineFlg: null },
          ],
          canPartialShipmentFlg: 0,
          canCombineFlg: 0,
        },
        tradingChannelInfo: {
          flowType: null,
          tradingChannelNo: 'TC20250625000004',
        },
        visibleFlg: 1,
        editableFlg: 1,
      },
    ],
  },
};
